import type { COUNTRY_CODE } from "consts";

// Type-only enum use: a runtime import of the consts barrel from inside it breaks tests that partially mock "consts".
export const ACQUISITION_SUPPORTED_COUNTRIES = ["DE" as COUNTRY_CODE.GERMANY, "PL" as COUNTRY_CODE.POLAND] as const;

export type AcquisitionSupportedCountry = (typeof ACQUISITION_SUPPORTED_COUNTRIES)[number];

export const ACQUISITION_OTHER_COUNTRY = "OTHER" as const;

export type AcquisitionCountrySelection = AcquisitionSupportedCountry | typeof ACQUISITION_OTHER_COUNTRY;

export const ACQUISITION_COUNTRY_OPTIONS: AcquisitionCountrySelection[] = [...ACQUISITION_SUPPORTED_COUNTRIES, ACQUISITION_OTHER_COUNTRY];

export const isAcquisitionCountrySupported = (country: AcquisitionCountrySelection | null): country is AcquisitionSupportedCountry =>
  country != null && (ACQUISITION_SUPPORTED_COUNTRIES as readonly string[]).includes(country);
